function hasNestedProperty(obj, propertyPath) {
  let returnVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!propertyPath) {
    return false;
  }
  propertyPath = propertyPath.replace(/^\./, '');
  const properties = propertyPath.split('.');
  for (let i = 0; i < properties.length; i++) {
    const prop = properties[i];
    if (!obj || !obj.hasOwnProperty(prop)) {
      return returnVal ? null : false;
    }
    obj = obj[prop];
  }
  return returnVal ? obj : true;
}
function itemIncludes(value, filter) {
  return value.toString().toLowerCase().includes(filter.toString().toLowerCase());
}
function getProp(target, key) {
  const hasNested = hasNestedProperty(target, key, true);
  return hasNested === null ? target[key] : hasNested;
}
function filterItems(prop, item, _ref) {
  let {
    value
  } = _ref;
  const itemValue = getProp(item, prop);
  if (itemValue == null) {
    return false;
  }
  return Array.isArray(value) ? value.some(val => itemIncludes(itemValue, val)) : itemIncludes(itemValue, value);
}

export { filterItems };
//# sourceMappingURL=utils.js.map
